module.exports = __webpack_public_path__ + "static/story4-635bd3bcd3d00ab5178b097f34fc5652.png";